;(function ( $ ) {

    /**
     *  listingTableHeader
     *  match width of table actions to table for large displays
     **/

    'use strict';

    // Create the defaults once
    var pluginName = 'listingTableHeader';
    var defaults = {};

    // The actual plugin constructor
    function Plugin ( element, options ) {
        this.element = element;
        this.settings = $.extend( {}, defaults, options );
        this._defaults = defaults;
        this._name = pluginName;
        this.init();
    }

    // Avoid Plugin.prototype conflicts
    $.extend(Plugin.prototype, {
        init: function () {
            this.$table = $(this.element).parent().find('table');
            this.$tableWrapper = $(this.element).parent().find('.responsive-table');
            this.registerEvents();
            this.resizeHeader();
        },

        registerEvents: function() {
            var _this = this;
            $(window).smartresize(function(){
                _this.resizeHeader();
            });
        },

        resizeHeader: function() {
            if ($(document).width()  > 1400 ) {
                var w = this.$table.width() + 40;
                if (this.$tableWrapper.width() < w) {
                    w = this.$tableWrapper.width();
                }
                $(this.element).width(w);
            } else {
                $(this.element).width('auto');
            }
        }
    });

    $.fn[ pluginName ] = function ( options ) {
        return this.each(function() {
            if ( !$.data( this, 'plugin_' + pluginName ) ) {
                $.data( this, 'plugin_' + pluginName, new Plugin( this, options ) );
            }
        });
    };
})( jQuery );
